import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon, HideOrShowAccountModalIcon } from 'assets';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import { useHideOrShowAccount } from 'view/pages/profile/hooks/useHideOrShowAccount';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';

const ProfileShowAccountModal: FC<{ hideCloseButton?: boolean }> = ({
  hideCloseButton = false,
}) => {
  const { role } = useCS(GlobalConfigContext, globalConfigSelectors.userData);
  const isOpenShowAccountModal: boolean = useCS(
    ProfileConfigContext,
    profileConfigSelectors.isOpenShowAccountModal
  );
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { isLoading, updateAccountPrivacy } = useHideOrShowAccount();

  const onClose = () => {
    if (update) update({ isOpenShowAccountModal: false });
  };

  const onShowClick = () => {
    updateAccountPrivacy({ showProfile: true });
  };

  return (
    <Modal
      open={isOpenShowAccountModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          <CS.ModalMainImage>
            <HideOrShowAccountModalIcon />
          </CS.ModalMainImage>
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Show your profile?</CS.ModalMainHeaderTitle>
            {role?.name === RolesEnum.JOB_SEEKER ? (
              <CS.ModalMainHeaderSubTitle>
                {'Your profile will be visible to employers \n and included in search results.'}
              </CS.ModalMainHeaderSubTitle>
            ) : (
              <CS.ModalMainHeaderSubTitle>
                {
                  'Your profile will be available for viewing to all users \n and will appear in the search results.'
                }
              </CS.ModalMainHeaderSubTitle>
            )}
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            variant="outlined"
            text="Show profile"
            onClick={onShowClick}
            disabled={isLoading}
          />
          <Button variant="contained" text="Cancel" onClick={onClose} />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default ProfileShowAccountModal;
